import Component from '../core/Component';
import $ from 'jquery';
import * as ViewportServices from '../services/Viewport';

export default class Scroll extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        this.$element.on('click', ::this.scroll);
    }

    scroll (event) {
        event.preventDefault();
        event.stopPropagation();
        ViewportServices.scrollTo($(this.$element.attr('href')).offset().top);
    }
}


// WEBPACK FOOTER //
// ./components/Scroll.js